<div class="login-form flex flex-col lg:flex-row min-h-screen">
    <div class="lg:w-7/12 w-full flex flex-col items-center justify-center bg-gray-100 p-6 leftSide">
        <div class="left-logo-screen">
            <div class="mb-4">
                <img src="assets/logo2.png" class="h-16" alt="Logo" />
            </div>
            <div class="mb-4">
                <img src="assets/tina2.png" class=" h-52 md:h-96" alt="Tina" />
            </div>
            <div class="text-center">
                <h2 class="text-2xl font-bold heading">Welcome To Gravitas AI</h2>
                <p class="text-lg italic text-gray-600 subheading">" Designing Tomorrow With Conversational AI "</p>
            </div>
        </div>
    </div>
    <div class="lg:w-5/12 w-full flex flex-col items-center justify-center p-6 rightSide">
        <form class="middleContainer" [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()" autocomplete="off">

            <div class="inputdiv">
                <div class="login-text">Reset Password</div>
                <div for="password" style="color: #fff; margin-bottom: 10px;">Password</div>


                <p-password class="passwordInput" [inputStyle]="{'box-shadow': '9px 10px 7.5px 2px #00000040 !important',
                    'border-radius': '30px !important',
                    'padding': '10px 20px !important'}" [style]="{'box-shadow': '9px 10px 7.5px 2px #00000040 !important',
                      'border-radius': '30px !important',
                      'padding': '10px 20px !important'}"
                    [ngClass]="{'ng-invalid ng-dirty': submitted && resetPasswordForm.get('password')?.invalid}"
                    inputStyleClass="passwordClass"
                    [toggleMask]="true" formControlName="password" name="password" autocomplete="new-password">

                    <ng-template #header>
                        <div class="font-semibold text-xm mb-1">
                        </div>
                    </ng-template>

                    <ng-template #footer>
                        <hr class="my-2 text-[#CDCBCB]" style="background-color: #CDCBCB;
                        height: 1px;
                        border-color: #CDCBCB;" />
                        <ul class="pl-2 ml-2 leading-normal flex flex-col gap-3 mt-3">
                            <li
                                [ngClass]="{'text-green-500': passwordCriteria.lowercase, 'text-red-500': !passwordCriteria.lowercase}">
                                <span *ngIf="passwordCriteria.lowercase" class="mr-2">✔</span>
                                <span *ngIf="!passwordCriteria.lowercase" class="mr-2">✖</span>
                                At least one lowercase
                            </li>

                            <li
                                [ngClass]="{'text-green-500': passwordCriteria.uppercase, 'text-red-500': !passwordCriteria.uppercase}">
                                <span *ngIf="passwordCriteria.uppercase" class="mr-2">✔</span>
                                <span *ngIf="!passwordCriteria.uppercase" class="mr-2">✖</span>
                                At least one uppercase
                            </li>
                            <li
                                [ngClass]="{'text-green-500': passwordCriteria.numeric, 'text-red-500': !passwordCriteria.numeric}">
                                <span *ngIf="passwordCriteria.numeric" class="mr-2">✔</span>
                                <span *ngIf="!passwordCriteria.numeric" class="mr-2">✖</span>
                                At least one numeric
                            </li>
                            <li
                                [ngClass]="{'text-green-500': passwordCriteria.minLength, 'text-red-500': !passwordCriteria.minLength}">
                                <span *ngIf="passwordCriteria.minLength" class="mr-2">✔</span>
                                <span *ngIf="!passwordCriteria.minLength" class="mr-2">✖</span>
                                Minimum 8 characters
                            </li>
                            <li
                                [ngClass]="{'text-green-500': passwordCriteria.noWhitespace, 'text-red-500': !passwordCriteria.noWhitespace}">
                                <span *ngIf="passwordCriteria.noWhitespace" class="mr-2">✔</span>
                                <span *ngIf="!passwordCriteria.noWhitespace" class="mr-2">✖</span>
                                Password cannot contain whitespace.
                            </li>
                        </ul>
                    </ng-template>

                </p-password>


                <small class="mtErr" *ngIf="submitted && resetPasswordForm.get('password')?.hasError('required')">
                    Field is required</small>

                <small class="mtErr" *ngIf="submitted && resetPasswordForm.get('password')?.hasError('pattern')">
                    Password must contain at least one number, one uppercase and one lowercase letter, and at least 8
                    characters.<br />
                    Password cannot contain whitespace.
                </small>

            </div>

            <div class="inputdiv" style="margin-top: 15px">
                <div>
                    <div for="confirmPassword" style="color: #fff; margin-bottom: 10px;">Confirm Password</div>
                    <p-iconfield>
                        <input pInputText id="confirmPassword" formControlName="confirmPassword" name="confirmPassword"
                            [type]="isConfirmPasswordVisible ? 'text' : 'password'" fullWidth pSize="large"
                            class="input-text w-full" autocomplete="on"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && resetPasswordForm.get('confirmPassword')?.invalid}" />

                        <p-inputicon class="pi cursor-pointer" [ngClass]="{'pi-eye-slash' : isConfirmPasswordVisible,
                          'pi-eye' : !isConfirmPasswordVisible}"
                            (click)="isConfirmPasswordVisible = !isConfirmPasswordVisible" style="margin-right: 9px;
                            font-size: 13.2px;
                            margin-top: -7px;" />
                    </p-iconfield>

                    <small class="mtErr"
                        *ngIf="submitted && resetPasswordForm.get('confirmPassword')?.hasError('required')">
                        Field is required</small>


                    <small class="mtErr text-red-500"
                        *ngIf="submitted && resetPasswordForm.get('confirmPassword')?.invalid &&  !resetPasswordForm.get('confirmPassword')?.hasError('required')">
                        Passwords do not match
                    </small>


                </div>
            </div>


            <!-- <p-password [(ngModel)]="value" autocomplete="off">
                <ng-template #header>
                    <div class="font-semibold text-xm mb-4">Pick a password</div>
                </ng-template>
                <ng-template #footer>
                    <p-divider />
                    <ul class="pl-2 ml-2 my-0 leading-normal">
                        <li>At least one lowercase</li>
                        <li>At least one uppercase</li>
                        <li>At least one numeric</li>
                        <li>Minimum 8 characters</li>
                    </ul>
                </ng-template>
            </p-password> -->

            <div class="w-full">
                <button class="w-full login-button" [disabled]="isLoading" type="submit">
                    <i class="pi" [ngClass]="{
                    'pi-spin pi-spinner': isLoading,
                    'pi-sign-in': !isLoading
                  }" style="margin-right: 7px;"></i>
                    {{ buttonTitle }}
                </button>
            </div>
        </form>
    </div>
</div>

<p-toast></p-toast>